export enum TestIdAction {
  VIEW = 'view',
  SELECT = 'select',
  COPY = 'copy',
  OPEN = 'open',
  TAB = 'tab',
  RETRY = 'retry',
  VIEW_SCHEMA = 'view-schema',
  COPY_CONTENT = 'copy-content',
  REFRESH = 'refresh',
  NAVIGATE = 'navigate',
  MULTI_SELECT = 'multi-select',
  UPLOAD_PHOTO = 'upload-photo',
  REMOVE_PHOTO = 'remove-photo',
  LOGOUT = 'logout',
}
